import { render, staticRenderFns } from "./UidTokenLogin.vue?vue&type=template&id=72b9c13c&scoped=true&"
import script from "./UidTokenLogin.vue?vue&type=script&lang=js&"
export * from "./UidTokenLogin.vue?vue&type=script&lang=js&"
import style0 from "./UidTokenLogin.vue?vue&type=style&index=0&id=72b9c13c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9c13c",
  null
  
)

export default component.exports